import { ReactNode, useEffect } from "react";
import { useCopyToClipboard } from "react-use";

import { Copy } from "~/assets";
import { cn } from "~/services/shadcn";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui";
import { ToastParams, useToast } from "../ui/use-toast";

export type CopyWrapperProps = {
  copyValue?: string | null | undefined;
  tooltip?: { content: ReactNode };
  toast?: ToastParams;

  children: ReactNode;
  className?: string;
  onClick?: () => void;
};

export const CopyWrapper = ({
  children,
  copyValue,
  tooltip,
  toast,
  className,
  onClick,
}: CopyWrapperProps) => {
  const [copyState, copy] = useCopyToClipboard();
  const { toast: showToast } = useToast();

  useEffect(() => {
    if (!copyState?.value) return;

    showToast({
      title: "Copied to clipboard!",
      duration: 1200,
      ...toast,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [copyState]);

  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger
        onClick={() => {
          if (copyValue) {
            copy(copyValue);
          }

          onClick?.();
        }}
        type="button"
        className={cn(
          "flex min-w-0 translate-x-2 items-center rounded-xs px-2 py-1 transition-colors duration-200 hover:bg-[#E7C5B71A]",
          className,
        )}
      >
        {children}
      </TooltipTrigger>

      <TooltipContent sideOffset={8} hidden={!tooltip?.content}>
        {tooltip?.content}
      </TooltipContent>
    </Tooltip>
  );
};

export const CopyWrapperIcon = ({ className }: { className?: string }) => {
  return <Copy className={cn("ml-1 h-3.5 w-3.5 fill-white", className)} />;
};
